"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cryptoIsReady = cryptoIsReady;
exports.cryptoWaitReady = cryptoWaitReady;

var _wasmCrypto = _interopRequireDefault(require("@polkadot/wasm-crypto"));

// Copyright 2017-2020 @polkadot/util-crypto authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
function cryptoIsReady() {
  return _wasmCrypto.default.isReady();
}

function cryptoWaitReady() {
  return _wasmCrypto.default.waitReady().then(() => true).catch(error => {
    console.error('Unable to initialize @polkadot/util-crypto', error);
    return false;
  });
} // start init process immediately


cryptoWaitReady().catch(() => {// shouldn't happen, logged above
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@polkadot/util-crypto/init.js
// module id = 390
// module chunks = 0